import { useState } from "react";

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:8080";

export function resolveProjectBannerUrl(bannerUrl) {
  if (typeof bannerUrl !== "string" || !bannerUrl.trim()) {
    return "";
  }
  return `${API_BASE}${bannerUrl.trim()}`;
}

export default function ProjectBannerImage({ bannerUrl, title, className }) {
  const src = resolveProjectBannerUrl(bannerUrl);
  const [failedSrc, setFailedSrc] = useState("");

  if (!src || failedSrc === src) {
    return null;
  }

  return (
    <img
      className={className}
      src={src}
      alt={`Баннер проекта${title ? ` ${title}` : ""}`}
      loading="lazy"
      onError={() => setFailedSrc(src)}
    />
  );
}
